import "./Footer.css";
import "../App.css";
import {Link} from "react-router-dom";

const Footer = () =>{

    return(
        <footer className="footer bg-dark py-5">
            <div className="container-footer grid grid-3">
                <div>
                    <h1>Justína n.o.</h1>
                    <p>Copyright &copy;</p>
                </div>
                <nav>
                    <ul>
                        <li><Link to="/" >Domov</Link></li>
                        <li><Link to="/Service" >Služby</Link></li>
                        <li><Link to="/Documents" >Na stiahnutie</Link></li>
                        <li><Link to="/Contact" >Kontakt</Link></li>
                        <li><Link to="/Gallery" >Fotogaléria</Link></li>
                    </ul>
                </nav>
                <div>
                    <h3>Kontakty</h3>
                    <ul>
                        <li><i className="fas fa-mobile-alt"></i> +421 905 811 685</li>
                        <li><i className="fas fa-mobile-alt"></i> +421 903 351 671</li>
                        <li><i className="far fa-envelope"></i> adosvita@gmail.com</li>
                    </ul>
                </div>
            </div>
        </footer>
    )
}

export default Footer;